/**
 * @generated SignedSource<<20e23359fa32fbb3bf0bc9a7d8a9702b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SelectActionItemGroupQuery$variables = {};
export type SelectActionItemGroupQuery$data = {
  readonly actionItemGroups: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly isDefaultGroup: boolean;
        readonly name: string;
        readonly order: number;
      };
    } | null>;
  };
};
export type SelectActionItemGroupQuery = {
  response: SelectActionItemGroupQuery$data;
  variables: SelectActionItemGroupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ActionItemGroupConnection",
    "kind": "LinkedField",
    "name": "actionItemGroups",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ActionItemGroupEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ActionItemGroupNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "order",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDefaultGroup",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectActionItemGroupQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SelectActionItemGroupQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5dbaeb68b45f082467657e3d2b66e8b5",
    "id": null,
    "metadata": {},
    "name": "SelectActionItemGroupQuery",
    "operationKind": "query",
    "text": "query SelectActionItemGroupQuery {\n  actionItemGroups {\n    edges {\n      node {\n        id\n        name\n        order\n        isDefaultGroup\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e2673a0cedec968d0798a06b2400f1d8";

export default node;
